<template>
    <Card :header="$t('details')" overlay :loading="request.getLoading()">

        <template #nav>
            <ButtonIcon v-if="product" @click="editProduct()">
                {{ $t('edit') }}
            </ButtonIcon>
        </template>

        <ErrorMessage :value="request.getError()" />

        <div v-if="product" class="grid-template">

            <div class="label">{{ $t('id') }}:</div>
            <div class="value">{{ product.id }}</div>

            <div class="label">{{ $t('sku') }}:</div>
            <div class="value">{{ product.sku }}</div>

            <div class="label">{{ $t('productId') }}:</div>
            <div class="value">{{ product.productId }}</div>

            <div class="label">{{ $t('ean') }}:</div>
            <div class="value">{{ product.ean }}</div>

            <div class="label">{{ $t('name') }}:</div>
            <div class="value">{{ product.name }}</div>

            <div class="label">{{ $t('description') }}:</div>
            <div class="value">{{ product.description }}</div>

            <div class="label">{{ $t('price') }}:</div>
            <div class="value"><template v-if="product.price">{{ $format.currency(product.price) }}</template></div>

            <div class="label">{{ $t('images') }}:</div>
            <div class="value">
                <div class="d-flex gap-2 flex-wrap">
                    <ImageLoader
                        v-for="(image, key) in product.images"
                        :key="key"
                        :src="image"
                        alt=""
                        size="50"
                        image-height="auto"
                        class="flex-shrink-0"
                        preview
                    />
                </div>
            </div>

            <div class="label">{{ $t('categories') }}:</div>
            <div class="value">
                <ul class="m-0 p-0 list-unstyled">
                    <li v-for="(categories, index) in product.categories" :key="index">
                        {{ categories.map(item => item.name).join(' > ') }}
                    </li>
                </ul>
            </div>

            <div class="label">{{ $t('space') }}:</div>
            <div class="value"></div>

            <div class="label ml-4">{{ $t('id') }}:</div>
            <div class="value">{{ product.space.id }}</div>

            <div class="label ml-4">{{ $t('name') }}:</div>
            <div class="value">{{ product.space.name }}</div>

            <div class="label ml-4">{{ $t('url') }}:</div>
            <div class="value">{{ product.space.url }}</div>

        </div>

    </Card>
</template>



<script>
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'Details',
        components: {
            ImageLoader,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestProduct,
                id: this.parentComponent.id,
            };
        },
        computed: {
            parentRoute() {
                return this.$route.params.parentUrl ? this.$router.resolve(this.$route.params.parentUrl).resolved : this.$route.matched.slice(-2)[0];
            },
            loading() {
                return this.request.getLoading();
            },
            product() {
                return this.request.getData();
            },
        },
        methods: {
            fetchProduct() {
                return this.request.get({ urlParams: { id: this.id } }).catch(() => {});
            },
            editProduct() {
                this.$root.$emit('bv::show::modal', 'modal-form-producer-products-product');
                this.$root.$emit('modal-form-producer-products-product', this.product);
            },
        },
        created() {
            this.fetchProduct();
        },
    };
</script>



<style lang="scss" scoped>
    .grid-template {
        display: grid;
        grid-template-columns: minmax(60px, max-content) auto;
        column-gap: 1rem;
        row-gap: 0.4rem;
        align-items: center;

        .label {
            font-weight: bold;
            margin-bottom: auto;
        }
    }
</style>
